import { post } from 'api/api';
import { z } from 'zod';
import { GetPointEligibleProgramsForListingsEndpoint } from '@kouto/types';
import ApiResponse from 'api/types/ApiResponse';

export type GetEligibleProgramResponse = z.infer<
  typeof GetPointEligibleProgramsForListingsEndpoint.responseSchema
>;

export type GetEligibleProgramRequest = z.infer<
  typeof GetPointEligibleProgramsForListingsEndpoint.requestSchema
>;

const getEligibleProgram = async (
  url: string,
  { brandId }: { brandId: string },
  body: GetEligibleProgramRequest,
) => {
  const response = await post<ApiResponse<GetEligibleProgramResponse>>(url, {
    body: JSON.stringify(body),
    headers: {
      'Kouto-Brand-Id': brandId,
      'Way-Brand-Id': brandId,
    },
  });
  return response.data;
};

export default getEligibleProgram;
